const CALENDAR_DATE_KEY = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Календарный день для `input[type="date"]` в формате `yyyy-MM-dd`. */
export type CalendarDateKey = string;

/** Проверяет валидный календарный ключ `yyyy-MM-dd`. */
export function isCalendarDateKey(raw: string): raw is CalendarDateKey {
    const m = CALENDAR_DATE_KEY.exec(raw.trim());
    if (m == null) return false;
    const y = Number(m[1]);
    const mo = Number(m[2]);
    const d = Number(m[3]);
    if (!Number.isFinite(y) || !Number.isFinite(mo) || !Number.isFinite(d)) {
        return false;
    }
    const date = new Date(y, mo - 1, d);
    if (Number.isNaN(date.getTime())) return false;
    return date.getFullYear() === y && date.getMonth() === mo - 1 && date.getDate() === d;
}

/** Проверяет валидный календарный ключ `yyyy-MM-dd`. */
export function isHtmlDateValue(raw: string): boolean {
    return isCalendarDateKey(raw);
}

/** Нормализует строку в календарный ключ или `null`. */
export function normalizeCalendarDateKey(raw: string): CalendarDateKey | null {
    const value = raw.trim();
    if (isCalendarDateKey(value)) return value;
    return null;
}
